import React, {useState, useEffect} from 'react';
import {Autocomplete, TextField, Paper} from '@mui/material';

export default function AutocompleteField({
    label,
    value,
    onChange,
    searchFunction,
    renderOption,
    getOptionLabel,
    placeholder,
    required = false,
    disabled = false,
    minSearchLength = 2
}) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');

    // Загрузка всех опций при монтировании (для случая minSearchLength = 0)
    useEffect(() => {
        if (minSearchLength === 0) {
            searchOptions('');
        }
    }, []);

    // Поиск опций при вводе
    useEffect(() => {
        if (inputValue && inputValue.length >= minSearchLength) {
            searchOptions(inputValue);
        } else if (minSearchLength === 0 && inputValue === '') {
            searchOptions('');
        } else {
            setOptions([]);
        }
    }, [inputValue, minSearchLength]);

    const searchOptions = async (query) => {
        if (!searchFunction) return;

        setLoading(true);
        try {
            const response = await searchFunction(query);
            setOptions(response.data || []);
        } catch (error) {
            setOptions([]);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (event, newValue) => {
        if (onChange) {
            onChange(newValue);
        }
    };

    const handleInputChange = (event, newInputValue) => {
        setInputValue(newInputValue);
    };

    const defaultGetOptionLabel = (option) => {
        if (!option) return '';
        return option.name || option.label || option.toString();
    };

    const defaultRenderOption = (props, option) => (
        <li {...props} key={option.id}>
            <div>
                <div style={{fontWeight: 'bold'}}>{option.name}</div>
                {option.address && (
                    <div style={{fontSize: '12px', color: '#666'}}>{option.address}</div>
                )}
                {option.companyType && (
                    <div style={{fontSize: '12px', color: '#666'}}>
                        {option.companyType === 'legal' ? 'Юридическое лицо' : 'Физическое лицо'}
                    </div>
                )}
            </div>
        </li>
    );

    return (
        <Autocomplete
            value={value}
            onChange={handleChange}
            inputValue={inputValue}
            onInputChange={handleInputChange}
            options={options}
            loading={loading}
            getOptionLabel={getOptionLabel || defaultGetOptionLabel}
            renderOption={renderOption || defaultRenderOption}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            noOptionsText={inputValue.length < minSearchLength ? `Введите минимум ${minSearchLength} символа` : 'Не найдено'}
            loadingText="Поиск..."
            PaperComponent={({children}) => (
                <Paper style={{maxHeight: 200, overflow: 'auto'}}>
                    {children}
                </Paper>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                    required={required}
                    disabled={disabled}
                    fullWidth
                    margin="dense"
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '&.Mui-focused fieldset': {
                                borderColor: '#f24405',
                                borderWidth: '2px'
                            }
                        },
                        '& .MuiInputLabel-root': {
                            '&.Mui-focused': {
                                color: '#f24405'
                            }
                        }
                    }}
                />
            )}
            style={{marginBottom: '8px'}}
        />
    );
}